import { Text, Flex, Icon } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next';

function ContactInfo() {
    const { t } = useTranslation();

    return (
        <Flex
            flexDirection={'column'}
            gap={{ base: '5%', md: '10%' }}
            p={{ base: '1%', md: '0%', lg: '5%' }}
            w={{ base: '100%', md: '80%', lg: '60%' }}
            ml={{ base: '0%', md: '35%', lg: '45%' }}
            maxH={'400px'}
        >
            <Flex flexDirection={'column'}>
                <Text color={'#d7b363'}
                    fontSize={{ base: '130%', md: '150%', lg: '180%' }}
                    fontFamily={'Avenir LT Pro'} fontWeight={'bold'}>
                    {t("contactus-tittle2")}
                </Text>
                <Text color={'white'}
                    fontSize={{ base: '120%', md: '110%', lg: '120%' }}
                    fontFamily={'Avenir LT Pro'} fontWeight={'medium'}>
                    sales@tmginternacional.com
                </Text>
            </Flex>
            <Flex flexDirection={'column'}>
                <Text color={'#d7b363'}
                    fontSize={{ base: '130%', md: '150%', lg: '180%' }}
                    fontFamily={'Avenir LT Pro'} fontWeight={'bold'}>
                    {t("contactus-tittle3")}
                </Text>
                <Text color={'white'}
                    fontSize={{ base: '120%', md: '110%', lg: '120%' }}
                    fontFamily={'Avenir LT Pro'} fontWeight={'medium'}>
                    ops@tmginternacional.com.
                </Text>
            </Flex>
            <Flex flexDirection={'column'}>
                <Text color={'#d7b363'}
                    fontSize={{ base: '130%', md: '150%', lg: '180%' }}
                    fontFamily={'Avenir LT Pro'} fontWeight={'bold'}>
                    {t("contactus-tittle4")}
                </Text>
                <Text color={'white'}
                    fontSize={{ base: '120%', md: '110%', lg: '120%' }}
                    fontFamily={'Avenir LT Pro'} fontWeight={'medium'}>
                    finance@tmginternacional.com.
                </Text>
            </Flex>

            <Flex flexDirection={'column'}>
                <Text color={'#d7b363'}
                    fontSize={{ base: '130%', md: '150%', lg: '180%' }}
                    fontFamily={'Avenir LT Pro'} fontWeight={'bold'}>
                    {t("contactus-tittle5")}
                </Text>
                <Text color={'white'}
                    fontSize={{ base: '120%', md: '110%', lg: '120%' }}
                    fontFamily={'Avenir LT Pro'} fontWeight={'medium'}>
                    admin@tmginternacional.com
                </Text>
            </Flex>

        </Flex>
    )
}

export default ContactInfo